import keyMirror from "ramda-extension/es/keyMirror";
export const affectedFieldsTypes = keyMirror({
    BY_DEEP_PATH: null,
    BY_RECORD: null,
    ALL: null
});
export const PRESERVE_STATE_STREAM_NAMES = [
    'formData$',
    'formFieldState$',
    'globalErrors$',
    'formState$'
];
